<template>
	<div id="hrms75e-detail-tab5" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab5">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRMS75EC6']['10'] }}
      </h3>
    </div>
    <div id="tab5" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="detail detail-responsive panel-detail-filter">
          <div class="col-md-8">
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-6 control-label">{{ labels['HRMS75EC4']['20'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detail.detail.desc_codempid }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-6 control-label">{{ labels['HRMS75EC4']['30'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detail.detail.desc_codcomp }}</div>
                </div>
              </div>
            </form>
            <form class="form-horizontal">
              <div class="form-group margin-b-5">
                <label class="col-md-6 control-label">{{ labels['HRMS75EC4']['40'] }}</label>
                <div class="col-md-6">
                  <div class="form-control readonly-field-color">{{ detail.detail.desc_codpos }}</div>
                </div>
              </div>
            </form>
          </div>
            <hrms-table  :columns="detailTab5Columns" 
                         :data="detail.table"
                         :maxRowspan="detailTab5MaxRowspan"
                         :searchDisp="false" /> 		
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'hrms75e-detail-tab5',
  props: [
    'labels',
    'labelsButton',
    'nowLang',
    'detail',
    'detailTab5Columns',
    'detailTab5MaxRowspan'
  ],
  methods: {
    approveEvent (dataRow) {
      console.log('Approve Event')
    }
  }
}
</script>


// WEBPACK FOOTER //
// detailTab5.vue?71c5849c